import 'angular:locale/data:ar';
import 'zone.js';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "ar";
